export type DayPeriod = 'day' | 'night'

export const getDayPeriod = (date: Date = new Date()): DayPeriod => {
  const hour = date.getHours()
  return hour >= 6 && hour < 18 ? 'day' : 'night'
}

export const getMillisecondsUntilNextTransition = (date: Date = new Date()): number => {
  const currentPeriod = getDayPeriod(date)
  const nextTransition = new Date(date)

  if (currentPeriod === 'day') {
    // Next transition: 18:00:00.000
    nextTransition.setHours(18, 0, 0, 0)
  } else {
    // Next transition: 06:00:00.000 (tomorrow if we're past 18:00)
    if (date.getHours() >= 18) {
      nextTransition.setDate(nextTransition.getDate() + 1)
    }
    nextTransition.setHours(6, 0, 0, 0)
  }

  return Math.max(nextTransition.getTime() - date.getTime(), 1_000)
}
